<h2 mat-dialog-title>{{ "Dispose.Dispose" | translate }}</h2>
<div *ngIf="checkDispose; else elseBlock">
  <mat-dialog-content>
    <div>
      <form class="w-100" [formGroup]="expForm" #formDirective="ngForm">
        <mat-form-field class="full-width">
          <mat-label
            >{{ "Dispose.Reason_for_Disposing" | translate }}
          </mat-label>
          <textarea
            matInput
            rows="6"
            cols="100"
            id="str"
            formControlName="reason"
            (input)="str = $event.target.value"
          ></textarea>
          <mat-error *ngIf="!str">{{
            "Dispose.Please_enter_a_reason_for_disposing" | translate
          }}</mat-error>
          <mat-error *ngIf="str && formInvalid()">{{
            "Dispose.Please_provide_a_valid_reason" | translate
          }}</mat-error>
        </mat-form-field>
      </form>
    </div>
  </mat-dialog-content>
</div>
<ng-template #elseBlock>
  <mat-dialog-content>
    <div>
      <form class="w-100" [formGroup]="expForm" #formDirective="ngForm">
        {{ "Dispose.DisposeCaseMessage" | translate }}
      </form>
    </div>
  </mat-dialog-content>
</ng-template>

<mat-dialog-actions class="float-end">
  <div class="buttons">
    <button
      mat-button
      mat-raised-button
      preventDoubleClick
      color="primary"
      (click)="onDispose()"
      class="two"
    >
      {{ "Dispose.Dispose" | translate }}
    </button>
    <button mat-raised-button mat-dialog-close class="one">
      {{ "Dispose.Cancel" | translate }}
    </button>
  </div>
</mat-dialog-actions>
